import React from 'react';
import _ from 'lodash';

import ExifImage from 'components/ExifImage';
import {default as Modal, withModal} from 'components/Modal';

import {MODALS} from 'ducks/frontDesk';

import closeIcon from './assets/close-icon.svg';
import './styles.css';

class PreviewDocumentModal extends React.Component<any> {
  render() {
    const {closeModal, data: {poid: {fileUrl, filename}}} = this.props;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.SUB_MEDIUM}
        className="PreviewDocumentModal">
        <Modal.Body>
          <div className="content colab-centered">
            <div className="closeIcon colab-centered colab-clickable">
              <img
                onClick={closeModal}
                src={closeIcon}
                alt="Close preview document modal"
              />
            </div>
            <div className="imageContainer">
              <ExifImage
                className="documentImage"
                src={fileUrl}
                alt={filename}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withModal(MODALS.PREVIEW_POID_DOCUMENT)(PreviewDocumentModal);
